import type { IconProps } from '@/components/icons/common'

export function CoinbaseWalletIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 111.28 28" width="118.28" height="28" className={className}>
      <path
        fill="currentColor"
        d="M52.43 7.54 49.6 18h-.02L46.63 7.54h-2l-2.9 10.44h-.03L38.8 7.56h-2.13L40.58 21h1.97l2.96-10.55h.03L48.58 21h2.04L54.4 7.54h-1.97Zm6.43 0-5.15 13.43h2.1l1.18-3.2h6l1.21 3.2h2.17l-5.2-13.43h-2.31Zm-1.24 8.48 2.33-6.33h.04l2.36 6.33h-4.73Zm43.6-8.48v1.75h4.45v11.68h2.02V9.29h4.45V7.54h-10.91ZM90.38 20.97h9.22V19.2h-7.2v-4.3h6.62v-1.73H92.4V9.3h7.2V7.54h-9.22v13.43ZM81.41 7.54h-2.03v13.43h8.79V19.2H81.4V7.54Zm-11 0H68.4v13.43h8.77V19.2h-6.75V7.54Zm-55.55 13.7a7 7 0 1 1 6.9-8.16h7.05a14 14 0 1 0 0 2.34h-7.05a7 7 0 0 1-6.9 5.83Z"
      />
    </svg>
  )
}
